<template>
  <div>
    <ul class="side-nav" v-if="windowWidth > 768">
      <li
        v-for="(section, sectionId) in sections.array"
        :key="sectionId"
        class="side-nav__item"
        :class="{active: sections.counter === sectionId}"
        @click="navigate(sectionId)"
      >
        <div class="fill"></div>
      </li>
    </ul>
    <div class="side-nav-mobile" :style="sideBarStyles" v-if="windowWidth <= 768">
      <div class="arrow"/>
      <div class="arrow"/>
    </div>
  </div>
</template>
<script>
import mixins from '@/mixins/mixins';

export default {
  mixins: [
    mixins
  ],
  computed: {
    sections() {
      return this.$store.state.sections;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    sideBarStyles() {
      const width = this.windowWidth / 5;
      return `
        width: calc(${width}px);
        left: ${this.windowWidth / 5 * this.sections.counter - width}px;`
    }
  },
  methods: {
    navigate(section) {
      if (section > this.sections.counter) {
        this.$store.commit('setSectionAnim', 'section-up');
        this.navigateTo(section)
      } else {
        this.$store.commit('setSectionAnim', 'section-down');
        this.navigateTo(section)
      }
    }
  }
}
</script>
